import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '../../../app/javascript/packs/jquery.toc'
import '../../../app/javascript/packs/jquery.toc.min'

// Support component names relative to this directory:
const componentRequireContext = require.context('components', true);
const ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);

window.Routes = require('routes');
import * as Routes from '../routes';
window.Routes = Routes;
